// useSmsBulk — Bulk Send composer state, ported from the prototype's bulk-send
// route in index.html. All values are mock/in-memory; "Review & Send" opens a
// confirmation modal whose action is a no-op (same as the standalone build).
import { ref, computed } from "vue";
import * as SMS from "../sms-config";

export function useSmsBulk() {
  // ── Compose ─────────────────────────────────────────────────────────────
  const bulkMsg = ref(SMS.BULK_DEFAULT_MSG);
  const bulkTextarea = ref(null); // DOM ref for caret-aware variable insertion
  const selectedTemplate = ref(0);

  const bulkVars = SMS.BULK_VARS;
  const bulkTemplates = SMS.BULK_TEMPLATES;

  function selectTemplate(i) {
    selectedTemplate.value = i;
  }

  // ── Segment count (single source = calcSegments) ──────────────────────────
  const bulkSeg = computed(() => SMS.calcSegments(bulkMsg.value));

  // ── Preview (first-recipient sample) ──────────────────────────────────────
  const bulkPreview = computed(() =>
    bulkMsg.value
      .replace(/\{\{recipient_name\}\}/g, "Sarah Chen")
      .replace(/\{\{order_number\}\}/g, "CAL-88291")
      .replace(/\{\{delivery_window\}\}/g, "12:00 PM – 5:00 PM")
      .replace(/\{\{[^}]+\}\}/g, "")
  );

  // Insert a variable at the caret (falls back to append if the ref is gone).
  function insertBulkVar(v) {
    const ta = bulkTextarea.value;
    if (!ta) {
      bulkMsg.value += v;
      return;
    }
    const s = ta.selectionStart;
    const e = ta.selectionEnd;
    bulkMsg.value = bulkMsg.value.slice(0, s) + v + bulkMsg.value.slice(e);
    requestAnimationFrame(() => {
      ta.focus();
      ta.selectionStart = ta.selectionEnd = s + v.length;
    });
  }

  return {
    bulkMsg,
    bulkTextarea,
    selectedTemplate,
    bulkVars,
    bulkTemplates,
    selectTemplate,
    bulkSeg,
    bulkPreview,
    insertBulkVar
  };
}
